export default [
  'juan@foodforjoe.es',
  'erika.lazaro@foodforjoe.es',
  'diego@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'almacen.massanes@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
  'sonia.cortes@foodforjoe.es',
];
